import * as dayjs from 'dayjs';

import * as minMax from 'dayjs/plugin/minMax';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import * as objectSupport from 'dayjs/plugin/objectSupport';
import * as quarterOfYear from 'dayjs/plugin/quarterOfYear';
import * as weekday from 'dayjs/plugin/weekday';
import * as duration from 'dayjs/plugin/duration';
import * as advanced from 'dayjs/plugin/advancedFormat';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(minMax);
dayjs.extend(objectSupport);
dayjs.extend(quarterOfYear);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(advanced);

export default dayjs;
